import { axiosGetHandler, axiosPostHandler } from './config';

// 获取游戏详情页数据，根据game_type请求不同的接口
export function getGameDetail(game_type, args) {
  let url = '';
  if (game_type === 'console') {
    url = '/game/console/get_game_detail/';
  } else if (game_type === 'mobile') {
    url = '/game/mobile/get_game_detail/';
  } else {
    url = '/game/get_game_detail/';
  }
  return axiosGetHandler(url, args);
}

/**
 * XGP_web
 *
 */
// 获取即将加入游戏列表
export function getComingSoonXboxGameList(args) {
  let url = '/game/xbox/v3/xgp/coming_soon';
  return axiosGetHandler(url, args);
}

// 获取即全部游戏列表
export function getAllXboxGameList(args) {
  let url = '/game/xbox/v3/xgp/game_list';
  return axiosGetHandler(url, args);
}

// 获取用户信息
export function getXboxUserInfo(args) {
  let url = '/game/xbox/v3/tier_info';
  return axiosGetHandler(url, args);
}

//获取link_id
//params: unique_key valorant + '_' + skin_id/true_skin_id
export function getToolLinkID(args) {
  let url = '/bbs/tool/get_tool_linkid';
  return axiosGetHandler(url, args);
}
